<template>
    <div class="form-group" :class="{'hide': (!props.show)}">
		<label :for="inputId" class="contact-form-label" v-if="labelText.length > 0">{{ labelText }}
			<span v-if="!props.isRequired" class="optional-text"> (optional)</span>
		</label>
            <button 
                :id="`${props.dropDownProps.dropdownElName}-button`"
                :data-dropdown-toggle="`${props.dropDownProps.dropdownElName}-dropdown`"
                class="gibs-checkbox-button"
                data-dropdown-placement="bottom"
                type="button">
                <span :id="`${props.dropDownProps.dropdownElName}-button-text`" :class="selectedOptionList?.length === 0? 'text-wildblueyonder': 'text-japaneseindigo'">
                    {{ inputDisplayValues }}
                </span>
                <nuxt-icon class="gibs-checkbox-dropdown-icon" name='form-dropdown-arrow' /> 
            </button>
            <!-- Dropdown menu -->
            <div :id="`${props.dropDownProps.dropdownElName}-dropdown`" 
                class="gibs-checkbox-dropdown" :class="`${props.dropDownProps.dropdownElName}-dropdown`">
                <ul class="gibs-checkbox-list" :aria-labelledby="`${props.dropDownProps.dropdownElName}-dropdown`" :id="inputId">
                    <template v-for="option in props.dropDownProps.optionList"> 
                        <li class="gibs-checkbox-item" @click="handleChange(option)">
                            <div class="gibs-checkbox-item-wrapper">
                            <input :id="'list-checkbox-' + option.id"
                                type="checkbox"
                                :value="option"
                                name="list-checkbox"
                                class="gibs-checkbox-item-input"
                                :checked="option.selected" />
                            <label class="gibs-checkbox-item-label" v-html="option.value!.replace(/\(([^)]+)\)/, '<b>($1)</b>')"> 
                            </label>
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
            
            <p :id="`${inputId}-error`" class="gibs-form-group-error gibs-small-regular"></p>
    </div>
</template>
    
<script setup lang="ts">
    import { Dropdown } from "flowbite";
    import type { DropdownOptions, DropdownInterface } from "flowbite";

    let filterDropdown: DropdownInterface;

    const props = defineProps({
        dropDownProps: {
            type: Object,
            default: itemObject
        },
        options: {
        type: Array<any>,
        required: true,
        default: []
        },
        filterTitle: {
        type: String,
        default: "Select"
        },
        labelText: {
            type: String,
            required: true,
            default: ''
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
        show: {
            type: Boolean,
            default: true
        },
        validatorRuleId: {
			type: String,
			default: null
		},
        validator: {
			type: Validation,
			default: null
		},
        inputId: {
            type: String,
            required: true,
        },
    });

    const inputDisplayValues = ref<string>(props.dropDownProps.filterDisplayValue);
    const selectedOptionList = ref(new Array<any>);

    const emitCheckbox = defineEmits<{
        checkboxSelection: [selectedOptions: any];
    }>();

    function setInputValueToDefaultOrCount() {
        inputDisplayValues.value = selectedOptionList.value.length > 0? `Selected (${selectedOptionList.value.length})` : props.dropDownProps.filterDisplayValue;
    }

    function handleChange(selectedOption: any) {
        const checkboxElement = document.getElementById("list-checkbox-" + selectedOption.id)  as HTMLInputElement; 
        selectedOption.selected = !selectedOption.selected;
        if (selectedOption.selected) {
            checkboxElement.checked = true;
            selectedOptionList.value.push(selectedOption);

            setInputValueToDefaultOrCount();
        } else {
            checkboxElement.checked = false;
            selectedOptionList.value.forEach((element, index) => {
                if (element.id === selectedOption.id) {
                    selectedOptionList.value.splice(index, 1);
                }
            });

            setInputValueToDefaultOrCount();
        }

        if (typeof(props.validator) !== 'undefined' && props.validator != null) { 
            props.validator.setValidationRuleSourceValue(props.validatorRuleId, selectedOptionList.value);
            let resultList = props.validator.validateRule(props.validatorRuleId);
            ApplyValidate(!props.validator.isValidationRuleValid(props.validatorRuleId), resultList);
        }
        emitCheckbox('checkboxSelection', selectedOptionList.value);
    }

    function setupDropdown() {
        const $filterButtonElement: HTMLElement = document.getElementById(`${props.dropDownProps.dropdownElName}-button`) as HTMLElement;
        const $filterListElement: HTMLElement = document.getElementById(`${props.dropDownProps.dropdownElName}-dropdown`) as HTMLElement;        

        const options: DropdownOptions = {
            placement: 'bottom',
            triggerType: 'click',
            offsetSkidding: 0,
            offsetDistance: 10,
            delay: 300,
            onHide: () => {
                
            },
            onShow: () => {
                
            },
            onToggle: () => {
                
            }
        };

        if ($filterButtonElement) {
            filterDropdown = new Dropdown($filterListElement, $filterButtonElement, options);
        }
    };

    onMounted (() => {
        selectedOptionList.value = props.dropDownProps.optionList.filter((option: any) => {
            return option.selected === true;
        });
        setInputValueToDefaultOrCount();
        setupDropdown();
    });

    // Re-sync selected items when the parent rebuilds optionList (e.g. CRM data loads after mount)
    watch(() => props.dropDownProps.optionList, (newList) => {
        if (newList) {
            selectedOptionList.value = newList.filter((option: any) => option.selected === true);
            setInputValueToDefaultOrCount();
        }
    }, { deep: true });

    onUpdated(() => {
        if (process.client) {
            setupDropdown();
        }
    });

    function ApplyValidate(isInvalid: boolean, validationResultList: Array<IValidationResult>) {
        const inputElement: HTMLElement = document.getElementById(`${props.dropDownProps.dropdownElName}-button`) as HTMLElement;
		//const inputElement = document.getElementById(props.inputId) as HTMLElement;
		const errorElement = document.getElementById(`${props.inputId}-error`) as HTMLElement;
		if (isInvalid) {
		inputElement.classList?.add("has-error");
		}
		else {
		inputElement.classList?.remove("has-error");
		}
		
		let errorString = '';
		if (typeof (props.validator) !== 'undefined' && props.validator != null) {
		errorString = props.validator.getValidationResultString(props.validatorRuleId);
		}
		errorElement.innerText = errorString;
	}
</script>

<script lang="ts">
    let itemObject: IDropdownButtonConfig = {
        dropdownElName: "multiselect",
        filterDisplayValue: "-- Please select --",
        defaultAllValue: "",
        optionList: []
    };
</script>
    